import {HTTP_METHODS} from '@/utils/constants/httpMethods';
import {buildQueryParams} from '@/utils/commons';

export const REWARDS_CONFIG = {
  REWARD_TYPES: {
    endPoint: 'dropdown-config?dropdownName=rewardTypes',
    method: HTTP_METHODS.GET
  },
  REWARD_SEGMENTS: {
    endPoint: 'dropdown-config?dropdownName=rewardSegments',
    method: HTTP_METHODS.GET
  },
  SAVE_DRAFT: {
    endPoint: 'rewards',
    method: HTTP_METHODS.POST
  },
  PUBLISH_REWARD: {
    endPoint: 'rewards',
    method: HTTP_METHODS.POST
  },
  GET_REWARD_DETAIL: (id) => ({
    endPoint: `rewards/${encodeURIComponent(id)}`,
    method: HTTP_METHODS.GET
  }),
  UPDATE_REWARD: {
    endPoint: 'rewards',
    method: HTTP_METHODS.PUT
  },
  DELETE_REWARD: (id) => ({
    endPoint: `rewards/${encodeURIComponent(id)}`,
    method: HTTP_METHODS.DELETE
  }),
  SEGMENTS_LIST: (queryParams) => ({
    endPoint: `user/segments/list?${buildQueryParams(queryParams)}`,
    method: HTTP_METHODS.POST
  }),
  DIGITAL_CODES_LIST: (queryParams) => ({
    endPoint: `rewards/digital-codes/list?${buildQueryParams(queryParams)}`,
    method: HTTP_METHODS.POST
  }),
  DIGITAL_CODES_LOW_INVENTORY: (queryParams) => ({
    endPoint: `rewards/digital-codes/low-inventory?${buildQueryParams(queryParams)}`,
    method: HTTP_METHODS.GET
  }),
  VALIDATE_REWARD_NAME: {
    endPoint: 'rewards/validate-name',
    method: HTTP_METHODS.GET,
    appendQueryParams: true
  },
  DIGITAL_CODES_DELETE: (queryParams) => ({
    endPoint: `rewards/digital-codes/delete?${buildQueryParams(queryParams)}`,
    method: HTTP_METHODS.POST
  }),
  REVOKE_REWARD: {
    endPoint: 'rewards/revoke',
    method: HTTP_METHODS.PATCH
  },
  REWARD_REPORT_DOWNLOAD: {
    endPoint: 'rewards/download-report',
    method: HTTP_METHODS.GET,
    appendQueryParams: true
  }
};
